import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

export class StoreDashboardApi extends BaseApi {
  async getUnreadMessageCounts(
    parameters: APIPaths["/store-app/dashboard/unread-message-counts"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/dashboard/unread-message-counts"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get("/store-app/dashboard/unread-message-counts", { params: parameters })).data;
  }

  async getVisitCounts(
    parameters: APIPaths["/store-app/dashboard/visit-counts"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/store-app/dashboard/visit-counts"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/store-app/dashboard/visit-counts", { params: parameters })).data;
  }
}
